// extracted by mini-css-extract-plugin
export default {"main":"BaseSimpleItemEditorForm_main__pZyLs"};